// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7066) return "static/chunks/7066-c62ab0776b0eab4c.js";
	if (chunkId === 7673) return "static/chunks/7673-d34ba6aba0a3915d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2542":"cf03b5a670420c0d","8084":"2bbd445e23a1c0ac","8710":"52d323c1845e11d1"}[chunkId] + ".js";
};